import { CartItem, ICart } from "../Interfaces/cart";
import { IApiResponse } from "../Interfaces/common";
import { IOrder } from "../Interfaces/order";
import { IProduct } from "../Interfaces/product";
import { ILogin, IRegister, IUser } from "../Interfaces/user";
import { handleGetUserFromLocalStorage } from "../utils/common";
import { SERVER_URL } from "./config";

const currentUser = JSON.parse(
  handleGetUserFromLocalStorage() as string
) as IUser;

export const loginApi = async (
  payload: Partial<ILogin>
): Promise<IApiResponse<IUser>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/accounts/login`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.status >= 400) {
          reject(res);
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const registerApi = async (
  payload: Partial<IRegister>
): Promise<IApiResponse<IRegister>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/accounts/register`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.status >= 400) {
          reject(res);
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** Cart api start */

export const getAllCartItem = async (
  userId: string
): Promise<IApiResponse<CartItem[]>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/carts/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addToCart = async (
  payload: ICart
): Promise<IApiResponse<ICart>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/carts/${payload.userId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteCartItem = async (
  payload: Partial<CartItem>
): Promise<IApiResponse<CartItem>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/carts`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.status >= 400) {
          reject(res);
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** Cart api end */

/** Product api start */

export const getAllProduct = async (
  pageNumber?: number
): Promise<IApiResponse<IProduct[]>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/products`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getProductById = async (
  productId: string
): Promise<IApiResponse<IProduct>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/products/${productId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createProduct = async (
  payload: IProduct
): Promise<IApiResponse<IProduct>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/products`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// export const updateProductById = async (
//   payload: ICart
// ): Promise<IApiResponse<ICart>> => {
//   return await new Promise((resolve, reject) => {
//     fetch(`${SERVER_URL}/products/${payload._id}`, {
//       method: "PUT",
//       body: JSON.stringify(payload),
//       headers: {
//         "Content-Type": "application/json; charset=UTF-8",
//         Authorization: `Bearer ${currentUser.accessToken}`,
//       },
//     })
//       .then(async (response) => {
//         const data = await response.json();
//         if (response.status >= 400) {
//           reject(data);
//         }
//         resolve(data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const deleteProduct = async (
  payload: IProduct
): Promise<IApiResponse<IProduct>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/products`, {
      method: "DELETE",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** Product api end */

/** Order api start */

export const getAllOrder = async (): Promise<IApiResponse<IOrder[]>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/orders`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOrderById = async (
  orderId: string
): Promise<IApiResponse<IOrder>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/orders/${orderId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createOrder = async (
  payload: IOrder
): Promise<IApiResponse<IOrder>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/orders`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateOrder = async (
  payload: IOrder
): Promise<IApiResponse<IOrder>> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/orders/${payload._id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** Order api end */

/** payment api start */

export const capturePayment = async (payload: {
  productIds: string[];
  finalAmount: number;
}): Promise<any> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/capturePayment`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        console.log("error 2");
        reject(err);
      });
  });
};

export const verifyPayment = async (payload: {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
  productIds: string[];
  userId: string;
}): Promise<any> => {
  return await new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/verifyPayment`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.status >= 400) {
          reject(data);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** payment api end */
